import React from 'react';

import { InputField } from 'basics';

import { FilterContainer } from 'components/ToolBar/styles';

export default function AwardToolbar({ updateFiltering }) {

	const handleTextFilter = (field, value) => {
		updateFiltering(field, 'contains', value.length >= 3 ? value : undefined);
	};

	return (
		<FilterContainer>
			<InputField
				label="Filtrar por nombre de premio"
				type="text"
				id="title"
				placeholder="ingrese por lo menos 3 letras"
				onChange={handleTextFilter}
			/>
		</FilterContainer>
	);
}
